import {http} from "Services/Http/HttpClient";

export const getPaymentTypes = async () : Promise<any> => {
    return await http.get('/payment-types')
}
